import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, Env } from '@contexts/AppContext';
import { User } from '@utils/backend-api/currentUser';

import Content from './Content';

interface PartnersProps {
  env: Env;
  initialCurrentUser?: User;
  isGdprRequired?: boolean;
  isWebview: boolean;
}

const queryClient = new QueryClient();

const Partners = ({
  env,
  initialCurrentUser,
  isWebview,
  isGdprRequired,
}: PartnersProps): JSX.Element => {
  return (
    <AppContextProvider
      env={env}
      initialCurrentUser={initialCurrentUser}
      isWebview={isWebview}
      isGdprRequired={isGdprRequired}
    >
      <QueryClientProvider client={queryClient}>
        <Content />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default Partners;
